/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2019, 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

export const FETCH_RECOMMENDATIONS_EXISTING_VALUE =
  'FETCH_RECOMMENDATIONS_EXISTING_VALUE';
export const ADD_RECOMMENDATIONS_EXISTING_VALUE =
  'ADD_RECOMMENDATIONS_EXISTING_VALUE';
export const FETCH_RECOMMENDATIONS_ERROR_EXISTING_VALUE =
  'FETCH_RECOMMENDATIONS_ERROR_EXISTING_VALUE';
export const FETCH_RECOMMENDATIONS_NEW_VALUE =
  'FETCH_RECOMMENDATIONS_NEW_VALUE';
export const ADD_RECOMMENDATIONS_NEW_VALUE = 'ADD_RECOMMENDATIONS_NEW_VALUE';
export const FETCH_RECOMMENDATIONS_ERROR_NEW_VALUE =
  'FETCH_RECOMMENDATIONS_ERROR_NEW_VALUE';

export const FETCH_RECOMMENDATION_SOURCES_START =
  'FETCH_RECOMMENDATION_SOURCES_START';
export const FETCH_RECOMMENDATION_SOURCES_SUCCESS =
  'FETCH_RECOMMENDATION_SOURCES_SUCCESS';
export const FETCH_RECOMMENDATION_SOURCES_ERROR =
  'FETCH_RECOMMENDATION_SOURCES_ERROR';

export const SET_RECOMMENDATION_SOURCES_START =
  'SET_RECOMMENDATION_SOURCES_START';
export const SET_RECOMMENDATION_SOURCES_SUCCESS =
  'SET_RECOMMENDATION_SOURCES_SUCCESS';
export const SET_RECOMMENDATION_SOURCES_ERROR =
  'SET_RECOMMENDATION_SOURCES_ERROR';

export const TOGGLE_FILE_UPLOADER = 'TOGGLE_FILE_UPLOADER';
export const TOGGLE_RECOMMENDATION_SOURCES = 'TOGGLE_RECOMMENDATION_SOURCES';
export const TOGGLE_REC_SOURCE_ASSISTANTS = 'TOGGLE_REC_SOURCE_ASSISTANTS';
